import { render, staticRenderFns } from "./ModalChangeChip.vue?vue&type=template&id=5e3afed8&scoped=true"
import script from "./ModalChangeChip.vue?vue&type=script&lang=js"
export * from "./ModalChangeChip.vue?vue&type=script&lang=js"
import style0 from "./ModalChangeChip.vue?vue&type=style&index=0&id=5e3afed8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3afed8",
  null
  
)

export default component.exports